import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

export default (function () {
    return {
        mapStatus: function mapStatus(status) {
            switch (status) {
                case 'workcomplete':
                    return 'completed';
                case 'specialistwaiting':
                case 'requested':
                case 'inprogress':
                case 'draft':
                    return 'inProgress';
                case 'expired':
                case 'declined':
                case 'canceled':
                    return 'offTrack';
                default:
                    return 'unknown';
            }
        },
        displayList: function displayList(values) {
            return values && values.join ? values.join(', ') : '';
        },
        hasServiceRequests: function hasServiceRequests() {
            return this.serviceRequests && this.serviceRequests.length > 0;
        },
        canShowPrimaryContact: function canShowPrimaryContact() {
            return ApplicationFeatures.hasFeature('role.producer') || this.policyType === 'WorkersComp';
        },
        isInProgress: function isInProgress(status) {
            return this.mapStatus(status) === 'inProgress';
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/claim/directives/ClaimServiceRequests/ClaimServiceRequestsCtrl.js
// module id = 1424
// module chunks = 0